"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkOrcadRequiredFiles = checkOrcadRequiredFiles;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const orcadValidation_1 = require("./orcadValidation");
function getParsedDesign(detail) {
    if (detail.cadTool !== 'orcad' || detail.semanticType !== 'schematic' || !detail.fileValidationResult?.isValid) {
        return undefined;
    }
    const value = detail.fileValidationResult.data.metadata[orcadValidation_1.OrCADXProjectMetadataKey.LogicalSchema];
    if (typeof value !== 'object' || value === null || !Array.isArray(value.Schematic)) {
        return undefined;
    }
    return value;
}
function designIsHierarchical(design) {
    for (const schematic of design.Schematic) {
        for (const page of schematic.Page ?? []) {
            const drawnRef = (page.DrawnInst ?? []).some((inst) => inst.ContentsLibName !== '' || inst.ContentsViewName !== '');
            const partRef = (page.PartInst ?? []).some((inst) => inst.ContentsViewType === 1);
            if (drawnRef || partRef) {
                return true;
            }
        }
    }
    return false;
}
function checkBinaryDsnRule(context) {
    const dsnExt = orcadValidation_1.OrCADXFileType.OrCADCaptureSchematic.toLowerCase();
    if (context.files.some((f) => f.relativePath.toLowerCase().endsWith(dsnExt))) {
        return [];
    }
    for (const detail of context.fileDetails) {
        if (!detail.relativePath.toLowerCase().endsWith(orcadValidation_1.OrCADXFileType.OrCADCaptureSchematicXml)) {
            continue;
        }
        const design = getParsedDesign(detail);
        if (!design || !designIsHierarchical(design)) {
            continue;
        }
        return [
            {
                type: 'required-file-check',
                severity: sigma_engine_shared_1.BoundaryLevel.Warning,
                message: `"${detail.relativePath}" is a hierarchical design provided as a .xml export; upload the original .dsn to preserve exact net naming`,
                rule: 'orcad-binary-dsn',
                cadTool: 'orcad',
                requiredFileExt: orcadValidation_1.OrCADXFileType.OrCADCaptureSchematic,
                triggeringFile: detail.relativePath,
                errorType: sigma_engine_shared_1.FileCollectionValidationErrorType.MissingRequiredFile,
            },
        ];
    }
    return [];
}
function checkOrcadRequiredFiles(context) {
    return checkBinaryDsnRule(context);
}
//# sourceMappingURL=orcadRequiredFiles.js.map